import cn from 'classnames'
import React, { FC, useState, useEffect, useRef, useMemo } from 'react'
import s from './Warning.module.css'
import Image from 'next/image'

const Warning = ({warning} : {warning : string}) =>{
    return <div className = {cn(s.root)}>
        {warning}
    </div>
}

export default Warning